/**
 * Authentication Routes
 *
 * Routes for sign in, sign up, forgot password, and reset password
 */

import React from "react";
import { Route } from "react-router-dom";
import SignInPage from "../../components/auth/SignInPage";
import SignUpPage from "../../components/auth/SignUpPage";
import { ForgotPasswordPage, ResetPasswordPage } from "../lazyComponents";

/**
 * Gets all authentication-related routes
 * @returns {Array} Array of Route elements
 */
export const getAuthRoutes = () => [
  // Sign in routes (multiple paths for same page)
  <Route key="signin" path="/signin" element={<SignInPage />} />,
  <Route key="login" path="/login" element={<SignInPage />} />,

  // Sign up routes (multiple paths for same page)
  <Route key="signup" path="/signup" element={<SignUpPage />} />,
  <Route key="register" path="/register" element={<SignUpPage />} />,

  // Password reset routes
  <Route
    key="forgot-password"
    path="/forgot-password"
    element={<ForgotPasswordPage />}
  />,
  <Route
    key="reset-password"
    path="/reset-password"
    element={<ResetPasswordPage />}
  />,
];
